$( document ).ready(function() {
// initialization of aos
   // AOS.init();
  var btn = $('#goTotop');

$(window).scroll(function() {
  if ($(window).scrollTop() > 300) {
    btn.addClass('show');
  } else {
    btn.removeClass('show');
  }
});

btn.on('click', function(e) {
  e.preventDefault();
  $('html, body').animate({scrollTop:0}, '300');
});
      $(window).scroll(function() {    
          var scroll = $(window).scrollTop();
      
           //>=, not <=
          if (scroll >= 500) {
              //clearHeader, not clearheader - caps H
              $(".shopify-section-group-footer-group").addClass("footer-sticky");
          }
      });
      $('.scroll-down').on('click', function(e) {
          $('html, body').animate({
              scrollTop: $(window).height()
          }, 1200);
      });
   $('.tab-links').on('click', function(e) {
            var target = $(this).attr("href");
          $('html, body').animate({
              scrollTop: $(target).offset().top
          }, 1200);
      });
  $('.featured .grid.product-grid').slick({
  arrows: false,
  dots: false,
  infinite: true,
  autoplay:true,
    autoplaySpeed: 0,
  cssEase: 'linear',
  speed: 2000,
  slidesToShow: 5,
  slidesToScroll: 1,
  pauseOnHover: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
  $('.collection-product .grid.product-grid').slick({
  arrows: false,
  dots: false,
  infinite: true,
  autoplay:true,
    autoplaySpeed: 0,
  cssEase: 'linear',
  speed: 2000,
  slidesToShow: 6,
  slidesToScroll: 1,
  pauseOnHover: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
});